const styleSheet = (theme: any) => ({
  tableDiv: {
    "&::-webkit-scrollbar": {
      "-webkit-appearance": "none",
      width: "7px",
      height: "8px"
    },

    "&::-webkit-scrollbar-thumb": {
      borderRadius: "6px",
      backgroundColor: "#D8DCE6",
      "-webkit-box-shadow": "0 0 1px rgba(255,255,255,.5)"
    }
  }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Table/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/hoc/Table/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }